import { ROUTES } from "@src/common/constants";
import { MenuStateProvider } from "@src/components/layouts/menu/menu-state-provider";
import { useIsDesktop } from "@src/hooks/use-is-desktop";
import { memo, useMemo } from "react";
import * as portals from "react-reverse-portal";
import { Outlet, useLocation } from "react-router-dom";
import { MantineProvider } from "./providers/mantine-provider";
import { MenuBarSkeleton } from "./public/menu-bar-skeleton";
import { MenuDrawerSkeleton } from "./public/menu-drawer-skeleton";
import { NavBarSkeleton } from "./public/nav-bar-skeleton";
import { SidebarSkeleton } from "./public/sidebar-skeleton";

export const PublicShellLayout = memo(() => {
	const location = useLocation();
	const isDesktop = useIsDesktop();

	const isCliLogin = location.pathname === ROUTES.cliLogin;

	const navBar = useMemo(() => <NavBarSkeleton />, []);

	const portalNode = useMemo(() => portals.createHtmlPortalNode(), []);
	portalNode.element.setAttribute("class", "h-full");

	if (isCliLogin) {
		return (
			<MantineProvider>
				<Outlet key={location.pathname} />
			</MantineProvider>
		);
	}

	return (
		<MantineProvider>
			<MenuStateProvider isDesktop={isDesktop}>
				<portals.InPortal node={portalNode}>{navBar}</portals.InPortal>

				<div className="flex flex-col h-dvh landscape:flex-row desktop-nav:flex-row">
					{isDesktop && (
						<SidebarSkeleton>
							<portals.OutPortal node={portalNode} />
						</SidebarSkeleton>
					)}

					{!isDesktop && <MenuBarSkeleton />}

					<div className="overflow-y-auto relative flex-1">
						<Outlet key={location.pathname} />

						{!isDesktop && (
							<MenuDrawerSkeleton>
								<portals.OutPortal node={portalNode} />
							</MenuDrawerSkeleton>
						)}
					</div>
				</div>
			</MenuStateProvider>
		</MantineProvider>
	);
});
